<template>
  <div class="add-doctor">
    <div class="add-doctor__list">
      <div
        v-for="doctor in updatedList"
        :key="doctor.id_doctor"
        class="add-doctor__item"
      >
        <div class="add-doctor__data">
          <img
            svg-inline
            src="../../../static/images/new-doctor.svg"
            alt="Novo Médico"
          >
          <div>
            <p>
              <b>
                {{ doctor.name }}
              </b>
            </p>
            <p><b>CRM</b> {{ doctor.crm }}/{{ doctor.uf }}</p>
          </div>
        </div>

        <div class="actions-container">
          <div
            id="delete"
            class="status-icon icon-delete-alt"
            @click="openDeleteModal(doctor)"
          >
            <md-tooltip
              md-delay="400"
              md-direction="top"
            >
              Excluir
            </md-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="!newDoctor"
      class="add-doctor__new"
    >
      <button @click="newDoctor = !newDoctor">
        <img
          svg-inline
          src="../../../static/images/add-doctor.svg"
          alt="Adicionar Médico"
        >
      </button>
      <span>Adicionar médico</span>
    </div>

    <transition name="slide-fade">
      <div
        v-show="newDoctor"
        class="add-doctor__card"
      >
        <h4 class="title-main">
          Adicionar médico
        </h4>
        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout
            md-flex="100"
            md-flex-medium="100"
            class="add-doctor__input-name"
          >
            <md-input-container
              id="doctorName"
              v-click-outside="doctorListClickOutsite"
            >
              <label>Nome do médico</label>
              <md-input
                id="txtName"
                v-model="doctorName"
                v-validate="'required'"
                data-vv-validate-on="none"
                name="txtName"
                maxlength="60"
                type="text"
                title=""
                placeholder="Nome do médico *"
                @change="handleDoctorInputChange()"
                @focus="handleDoctorInputfocus()"
              />
              <Spinner v-show="loading" />
              <div
                v-if="showDoctorList && filteredArray.length > 0" 
                class="add-doctor__results"
              >
                <div
                  v-for="(doctor, index) in filteredArray"
                  :key="index"
                  class="add-doctor__results-item"
                  @click="handleSelectDoctor(doctor)"
                >
                  <div class="add-doctor__results-item-name">
                    {{ doctor.name }}
                  </div>
                  <div class="add-doctor__results-item-crm">
                    {{ doctor.crm + '/' + doctor.uf }}
                  </div>
                </div>  
              </div>
              <button
                v-if="isDoctorSelected"
                class="add-doctor__close"
                @click="resetInput()"
              >
                <img
                  src="/static/images/icon-close.svg"
                  alt="icone-fechar"
                >
              </button>
            </md-input-container>
          </md-layout>
          
          <md-layout
            md-flex="50"
            md-flex-medium="50"
            class="add-doctor__input-crm"
          >
            <md-input-container
              id="doctorCRM"
              :class="{
                'md-input-disabled': isDoctorSelected,
              }"
            >
              <label>CRM*</label>
              <md-input
                id="txtCRM"
                v-model="doctorCRM"
                v-validate="'required'"
                v-mask="'##########'"
                data-vv-validate-on="none"
                name="txtCRM"
                maxlength="10"
                type="text"
                title=""
                placeholder="CRM*"
                :disabled="isDoctorSelected"
              />
            </md-input-container>
          </md-layout>

          <md-layout
            md-flex="50"
            md-flex-medium="50"
            class="add-doctor__input-uf"
          >
            <md-input-container
              id="doctorUF"
              name="UF"
              :class="{
                'md-input-placeholder md-advanced-select': true,
                'md-has-value': doctorUF,
                'md-input-disabled': isDoctorSelected,
                'md-input-invalid': errors.has('feature'),
              }"
            >
              <label for="txtUF">UF*</label>
              <AdvancedSelect
                id="txtUF"
                v-model="doctorUF"
                v-validate="'required'"
                :options="optionsUF"
                placeholder=""
                name="txtUF"
                data-vv-validate-on="none"
                title=""
              />
            </md-input-container>
          </md-layout>
        </md-layout>

        <div class="add-doctor__buttons">
          <button
            class="btn-cancel"
            @click="cancel()"
          >
            Cancelar
          </button>

          <button
            v-if="isDoctorSelected"
            id="newDoctorBtn"
            class="btn-primary"
            :disabled="addDisabled"
            @click="saveDoctor()"
          >
            Adicionar
          </button>

          <button
            v-else
            id="newDoctorBtn"
            class="btn-primary"
            :disabled="addDisabled"
            @click="createDoctor()"
          >
            Adicionar
          </button>
        </div>
      </div>
    </transition>

    <modal
      ref="deleteDoctor"
      template="question"
      title="Aviso"
      ref-name="deleteDoctor"
      first-button-text="Cancelar"
      second-button-text="Excluir"
      @first-cta="closeDeleteModal()"
      @second-cta="deleteDoctorSelected()"
    >
      <p>Tem certeza que deseja desvincular este(a) médico(a)?</p>
      <div class="patients-list__modal-text">
        <span v-html="selectedDoctor ? selectedDoctor.name : ''" />
      </div>
    </modal>

    <modal
      ref="modalDoctorWarning"
      template="neutral"
      title="Aviso"
      ref-name="modalDoctorWarning"
      first-button-text="CONCLUIR"
      :icon-enabled="false"
      :close-button-enabled="false"
      class="modal-doctor-warning"
      @first-cta="closeWarningModal()"
    >
      <div class="modal-container">
        <div class="content">
          <div class="img-wrapper">
            <img
              src="/static/images/icon-alert-modal.svg"
              alt="icone-alerta"
            >
          </div>
          <span> Esse médico já foi relacionado com o paciente. </span>
        </div>
        <button
          class="highlight"
          @click="closeWarningModal"
        >
          OK
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import AdvancedSelect from '@/components/common/AdvancedSelect'
import Spinner from '@/components/common/Spinner'
import doctorService from '@/api/doctor'
import { mask } from 'vue-the-mask'
import strings from '@/strings'
import fuzzysort from 'fuzzysort'
import { clickOutside } from '@/utils/directives'

export default {
  name: 'AddDoctor',
  components: {
    AdvancedSelect,
    Spinner
  },
  directives: {
    mask: mask,
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his children
          if (!(el === event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      }
    },
    clickOutside
  },
  props: {
    listDoctor: {
      type: Array,
      default: []
    },
    opened: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      showDoctorList: false,
      isDoctorSelected: false,
      doctors: [],
      newDoctor: false,
      optionsUF: strings.brazilStates,
      doctorName: null,
      doctorCRM: null,
      doctorUF: null,
      addEnable: false,
      isSearchingDoctor: 'Nome do médico',
      loading: false,
      selectedDoctor: '',
      updatedList: [],
      doctorAlreadyExists: false,
      doctorSelected: null
    }
  },
  computed: {
    addDisabled () {
      if (
        this.doctorName &&
        this.doctorName.length > 0 &&
        this.doctorCRM &&
        this.doctorCRM.toString().length > 0 &&
        this.doctorUF &&
        this.doctorUF.value.length > 0
      ) {
        return false
      }
      return true
    },
    filteredArray () {
      if (this.doctorName) {
        if (this.doctorName.length > 0) {
          let result = fuzzysort.go(this.doctorName, this.doctors, {
            keys: ['name'],
            limit: 100,
            allowTypo: true,
            threshold: -10000
          })
          result = result.map((item) => {
            item = item.obj
            return item
          })
          return result
        }
      } else {
        return this.doctors
      }
    },
    inputDoctorCrm () {
      return document.getElementById('txtName')
    },
    inputDoctorUf () {
      return document.getElementById('txtName')
    }
  },
  mounted () {
    doctorService.getDoctors()
      .then((res) => {
        this.doctors = res.data
      })
    this.updatedList = this.listDoctor
    if (this.opened) {
      this.newDoctor = true
    }
  },
  methods: {
    resetInput () {
      this.doctorName = null
      this.doctorUF = null
      this.doctorCRM = null
      this.isDoctorSelected = false
    },
    handleDoctorInputChange () {
      this.isDoctorSelected = false
    },
    doctorListClickOutsite () {
      this.showDoctorList = false
    },
    handleDoctorInputfocus () {
      this.showDoctorList = true
    },
    handleSelectDoctor (doctor) {
      this.doctorSelected = doctor
      this.showDoctorList = false
      this.isDoctorSelected = true
      this.doctorName = doctor.name
      this.doctorCRM = doctor.crm
      this.doctorUF = {value: doctor.uf, label: doctor.uf}
    },
    verifyInputValues () {
      this.doctorName = ''
      this.inputDoctorName.disabled = true
      this.addEnable = false

      if (this.doctorCRM && this.doctorCRM.length >= 4 && this.doctorUF) {
        this.isSearchingDoctor = 'Buscando médico...'
        this.loading = true

        const uf = this.doctorUF.value.toLowerCase()

        doctorService
          .getDoctorByCrmAndUf(this.doctorCRM, uf)
          .then((response) => {
            this.doctorAlreadyExists = true
            this.doctorSelected = response.data
            this.addEnable = true
            this.doctorName = response.data.name
            this.loading = false
          })
          .catch(() => {
            this.doctorAlreadyExists = false
            this.doctorSelected = null
            this.isSearchingDoctor = 'Nome do médico'
            this.loading = false
            this.inputDoctorName.disabled = false
          })
      } else {
        this.isSearchingDoctor = 'Nome do médico'
        this.inputDoctorName.disabled = true
      }
    },
    saveDoctor () {
      const doctorFound = this.updatedList.some((doctor) => {
        if ('' + doctor.crm === this.doctorCRM && doctor.uf === this.doctorUF.value) return true
      })

      if (!doctorFound) {
        this.updatedList.push(this.doctorSelected)
        this.$emit('update', this.updatedList)
        this.newDoctor = false
        this.doctorName = ''
        this.doctorCRM = ''
        this.doctorUF = ''
      } else {
        this.openWarningModal()
      }
    },
    createDoctor () {
      const doctorData = {
        name: this.doctorName,
        crm: this.doctorCRM,
        uf: this.doctorUF.value
      }

      const doctorFound = this.updatedList.some((doctor) => {
        if ('' + doctor.crm === this.doctorCRM && doctor.uf === this.doctorUF.value) return true
      })

      if (!doctorFound) {
        doctorService.createDoctor(doctorData).then((res) => {
          const doctor = res.data
          this.updatedList.push(doctor)
          this.$emit('update', this.updatedList)
          this.newDoctor = false
          this.doctorName = ''
          this.doctorCRM = ''
          this.doctorUF = ''
        })
      } else {
        this.openWarningModal()
      }
    },
    cancel () {
      this.newDoctor = false
      this.doctorName = ''
      this.doctorCRM = ''
      this.doctorUF = ''
    },
    deleteDoctorSelected () {
      this.updatedList = this.listDoctor
      this.updatedList = this.updatedList.filter((doctor) => {
        return doctor.crm !== this.selectedDoctor.crm
      })

      this.$emit('update', this.updatedList)
      this.closeDeleteModal()
    },
    closeDeleteModal () {
      this.$refs.deleteDoctor.close()
    },
    openDeleteModal (doctor) {
      this.selectedDoctor = doctor
      this.$refs.deleteDoctor.open()
    },
    openWarningModal () {
      this.$refs.modalDoctorWarning.open()
    },
    closeWarningModal () {
      this.$refs.modalDoctorWarning.close()
    }
  }
}
</script>

<style lang="scss">
#doctorName {
  position: relative;
}
.add-doctor {

  .md-input-disabled {
    background: #f4f4f4;
    pointer-events: none;
    color: rgba(0,0,0,.38);

    .multiselect__single {
      color: rgba(0,0,0,.38);
    }
  }

  &__close {
    position: absolute;
    background: transparent;
    right: 5px;
    top: 8px;
  
    &:hover {
      opacity: 0.9;
    }
  }
  &__results {
    position: absolute;
    top: 48px;
    background-color: #fff;
    z-index: 1;
    box-shadow: 0 4px 5px 1px rgba(0, 0, 0, 0.1);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    width: 100%;
    max-height: 276px;
    overflow: auto;
    overflow-x: hidden;
  }

  &__results-item {
    font-size: 14px;
    color: #4a4a4a;
    line-height: 26px;
    padding: 10px 16px;
    cursor: pointer;
    display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between;

    &:hover {
      background-color: #ddd;
    }
  }

  &__item {
    color: #7a7a77;
    padding: 20px 27px;
    margin-top: 24px;
    background-color: #fff;
    border-radius: 6px;
    display: flex;
    height: 90px;
    align-items: center;
    justify-content: space-between;

    svg {
      width: 40px;
      height: 40px;
      margin-right: 15px;
    }

    p {
      font-size: 16px;
    }
  }

  &__data {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
  }

  &__new {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    margin: 24px 0;

    button {
      height: 45px;
      width: 45px;
      display: flex;
      border: 1px dashed #7f1a54;
      margin-right: 15px;
      align-items: center;
      justify-content: center;
      border-radius: 6px;

      &:hover {
        svg {
          width: 70%;
        }
      }

      svg {
        width: 50%;
        transition: width ease 0.3s;
      }
    }

    span {
      color: #7f1a54;
      font-size: 14px;
    }
  }

  &__card {
    padding: 20px 27px;
    margin-top: 24px;
    background-color: #fff;
    border-radius: 6px;

    #doctorName {
      display: flex;
      align-items: center;
    }
  }

  &__buttons {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;

    button {
      padding: 5px 37px;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      font-size: 12px;
      letter-spacing: 0.8px;

      &.btn-primary {
        font-weight: 500;
      }

      &.btn-cancel {
        background: none;
        border: 2px solid #7f1a54;
        color: #7f1a54;
        margin-right: 15px;
      }
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .slide-fade-enter-active {
    transition: all 0.3s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }

  .loader {
    width: 25px;
    height: 25px;
    border-top: 0.5em solid rgba(127, 26, 84, 0.2);
    border-right: 0.5em solid rgba(127, 26, 84, 0.2);
    border-bottom: 0.5em solid rgba(127, 26, 84, 0.2);
    border-left: 0.5em solid #7f1a54;
  }
}

.modal-doctor-warning {
  .standard-modal__title {
    &:before {
      content: "";
      display: inline-block;
      width: 17px;
      height: 16px;
      background-image: url("/static/images/icon-alert-modal.svg");
      margin-right: 9px;
      position: relative;
      top: 2px;
    }
  }
  .modal-container {
    text-align: center;
    .content {
      text-align: left;
      color: #4a4a4a;
      font-size: 14px;
      padding: 13px 12px 12px;
      background-color: #fdedd3;
      max-width: 420px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      border-radius: 5px;
      .img-wrapper {
        width: 32px;
      }
      span {
        letter-spacing: 0;
        color: #4a4a4a;
        font-size: 14px;
        width: calc(100% - 32px);
      }
    }
    .highlight {
      background-color: #7f1a54;
      height: auto;
      padding: 12px 60px;
      font-size: 12px;
      letter-spacing: 1px;
      border-radius: 3px;
      margin: 15px auto 5px;
    }
  }
}
</style>
